"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreThemes = require("@legacy-vfuk/core-themes");

var _coreBlock = _interopRequireDefault(require("@legacy-vfuk/core-block"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/FunctionalContentBlock.style"));

var _components = require("./components");

var _FunctionalContentBlock2 = _interopRequireDefault(require("./themes/FunctionalContentBlock.theme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FunctionalContentBlock = function FunctionalContentBlock(_ref) {
  var content = _ref.content,
      _ref$mediaPosition = _ref.mediaPosition,
      mediaPosition = _ref$mediaPosition === void 0 ? 'center' : _ref$mediaPosition,
      heading = _ref.heading,
      primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      footnote = _ref.footnote,
      children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      localTheme = _ref.localTheme,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'FunctionalContentBlock';
  var functionalContentBlockTheme = (0, _coreThemes.useLocalTheme)(componentName, _FunctionalContentBlock2["default"], localTheme);
  var _functionalContentBlo = functionalContentBlockTheme.appearance[appearance],
      blockAppearance = _functionalContentBlo.blockAppearance,
      inverseContent = _functionalContentBlo.inverseContent;
  return /*#__PURE__*/_react["default"].createElement(_coreBlock["default"], {
    appearance: blockAppearance,
    paddingLevel: 0,
    id: id,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    dataAttributes: _objectSpread({
      'data-component-name': componentName
    }, dataAttributes)
  }, /*#__PURE__*/_react["default"].createElement(Styled.FunctionalContentBlock, {
    mediaPosition: mediaPosition
  }, children && (mediaPosition === 'left' || mediaPosition === 'right') && children, /*#__PURE__*/_react["default"].createElement(Styled.ContentWrapper, {
    mediaPosition: mediaPosition
  }, heading && /*#__PURE__*/_react["default"].createElement(_components.Header, {
    inverse: inverseContent,
    heading: heading,
    position: mediaPosition,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  }), content && /*#__PURE__*/_react["default"].createElement(_components.ContentRenderer, {
    inverse: inverseContent,
    content: content,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'content')
  }), children && mediaPosition === 'center' && children, ((primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text) || (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text)) && /*#__PURE__*/_react["default"].createElement(_components.ButtonGroup, {
    inverse: inverseContent,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    mediaPosition: mediaPosition,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'button-group')
  }), footnote && /*#__PURE__*/_react["default"].createElement(_components.Footnote, {
    inverse: inverseContent,
    icon: footnote === null || footnote === void 0 ? void 0 : footnote.icon,
    text: footnote === null || footnote === void 0 ? void 0 : footnote.text,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'footnote')
  }))));
};

FunctionalContentBlock.displayName = "FunctionalContentBlock";
var _default = FunctionalContentBlock;
exports["default"] = _default;
//# sourceMappingURL=FunctionalContentBlock.js.map